import styled from 'styled-components';
import { devices } from '../../globalStyle';

export const MenuContainer = styled.div`
    position: fixed;
    background-color: #fff;
    width: 15vw;
    min-width: 260px;
    max-width: calc(100vw - 24px);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    z-index: 1000;
    border: 1px solid #ebebeb;
    border-radius: 0.5rem;
    box-shadow: 0px 8px 16px 0px #0000001A;
    @media ${devices.largeDesktop} {
        width: 12vw;
    }
`;

export const BuilderRow = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
`;

export const FilterInput = styled.input`
    background-color: transparent;
    width: 100%;
    height: 100%;
    border: 0;
    padding: 0 0.5rem;
    font-size: 0.9rem;
    cursor: pointer;

    &:focus {
        outline: none;
        box-shadow: none;
    }
`;

export const FilterSelectWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    background-color: #EBEBEB;
    width: 100%;
    height: 40px;
    border-radius: 20px;
    padding: 0 0.5rem;
    &.interval {
        flex-direction: column;
        height: auto;
        gap: 0.2rem;
        align-items: stretch;
        justify-content: center;
    }
`;

export const ApplyButton = styled.button`
    width: 100%;
    height: 40px;
    margin-top: 0.5rem;
    background-color: #0090D3;
    color: #fff;
    border: 0;
    border-radius: 20px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background-color 0.3s;
`;